import apiClient from './apiClient';
import type { TestScript, TestScriptPurpose } from '../types/types';

export type UpdateTestScriptDto = {
    name: string;
};

const testScriptsService = {
    getAll: async (purpose?: TestScriptPurpose): Promise<TestScript[]> => {
        const res = await apiClient.get<TestScript[]>('/test-scripts', {
            params: purpose ? { purpose } : undefined,
        });
        return res.data;
    },

    getById: async (id: number): Promise<TestScript> => {
        const res = await apiClient.get<TestScript>(`/test-scripts/${id}`);
        return res.data;
    },

    create: async (name: string, purpose: TestScriptPurpose, file: File): Promise<TestScript> => {
        const formData = new FormData();
        formData.append('name', name);
        formData.append('purpose', purpose);
        formData.append('file', file);
        const res = await apiClient.post<TestScript>('/test-scripts', formData, {
            headers: { 'Content-Type': undefined },
        });
        return res.data;
    },

    update: async (id: number, dto: UpdateTestScriptDto): Promise<TestScript> => {
        const res = await apiClient.patch<TestScript>(`/test-scripts/${id}`, dto);
        return res.data;
    },

    download: async (id: number): Promise<Blob> => {
        const res = await apiClient.get<Blob>(`/test-scripts/${id}/content`, {
            responseType: 'blob',
        });
        return res.data;
    },

    replaceFile: async (id: number, file: File): Promise<TestScript> => {
        const formData = new FormData();
        formData.append('file', file);
        const res = await apiClient.put<TestScript>(`/test-scripts/${id}/file`, formData, {
            headers: { 'Content-Type': undefined },
        });
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/test-scripts/${id}`);
        return res.data;
    },
};

export default testScriptsService;
